import withCurrentUser from './withCurrentUser';

export { withCurrentUser };



// WEBPACK FOOTER //
// ./src/modules/auth/containers/index.js